/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-preview-button',
  templateUrl: './preview-button.component.html',
  styleUrls: ['./preview-button.component.scss'],
})
export class PreviewButtonComponent implements OnInit {
  @Input() link: Array<string>;
  @Input() params: object;

  constructor() {}

  ngOnInit() {}
}
